<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="goback">
        <div @click="goback">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="content">
        <div class="fild_label">
          <span>*</span>
          <div>考评标题</div>
        </div>
        <div class="fild_value">
          <el-select
            v-model="valueTitle"
            placeholder="请选择考评标题"
            clearable
            @change="changeTitle"
          >
            <el-option
              v-for="item in optionTitle"
              :key="item.id"
              :label="item.activityTitle"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="evaluationMes" v-if="activityDescription">
          活动描述：{{ activityDescription }}
        </div>
        <div class="box_list" @click="toEvaluation('下属')" v-if="list3.length > 0">
          <div class="title">上级</div>
          <div class="username">
            {{ list3.join(",") }}
          </div>
          <div class="tag green" v-if="statusObj['上级']">已完成</div>
          <div class="tag red" v-if="statusObj['上级'] == false">待考评</div>
          <div class="line_two"></div>
          <div class="fot">{{ statusObj['上级'] ? '查看详情 >' : '前往评价 >' }}</div>
        </div>
        <div class="box_list" @click="toEvaluation('同事')" v-if="list2.length > 0">
          <div class="title">同事</div>
          <div class="username">
            {{ list2.join(",") }}
          </div>
          <div class="tag green" v-if="statusObj['同事']">已完成</div>
          <div class="tag red" v-if="statusObj['同事'] == false">待考评</div>
          <div class="line_two"></div>
          <div class="fot">{{ statusObj['同事'] ? '查看详情 >' : '前往评价 >' }}</div>
        </div>
        <div class="box_list" @click="toEvaluation('本人')" v-if="list4.length > 0">
          <div class="title">本人</div>
          <div class="username">
            {{ list4.join(",") }}
          </div>
          <div class="tag green" v-if="statusObj['本人']">已完成</div>
          <div class="tag red" v-if="statusObj['本人'] == false">待考评</div>
          <div class="line_two"></div>
          <div class="fot">{{ statusObj['本人'] ? '查看详情 >' : '前往评价 >' }}</div>
        </div>
        <div class="box_list" @click="toEvaluation('上级')" v-if="list1.length > 0">
          <div class="title">下属</div>
          <div class="username">
            {{ list1.join(",") }}
          </div>
          <div class="tag green" v-if="statusObj['下属']">已完成</div>
          <div class="tag red" v-if="statusObj['下属'] == false">待考评</div>
          <div class="line_two"></div>
          <div class="fot">{{ statusObj['下属'] ? '查看详情 >' : '前往评价 >' }}</div>
        </div>
        <!-- <div class="btn" style="margin-top: 30px">
          <el-button
            type="success"
            :disabled="valueTitle"
            @click="toUrl('/evaluation/introduce')"
            >开始考评</el-button
          >
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/evaluation";
// import moment from "moment";
export default {
  components: {},
  data() {
    return {
      userinfo: {},
      valueObject: "",
      valueTitle: "",
      optionObject: [],
      optionTitle: [],
      message: "",
      tagList: [],
      flagTime: false,
      evaluationTime: "",
      activityDescription: "",
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      statusObj:{}
    };
  },
  mounted() {
    const loginEvaluation = JSON.parse(sessionStorage.getItem("loginEvaluation"));
    if (loginEvaluation) {
       this.userinfo = loginEvaluation;
    } else {
      this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    }
    // this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    console.log(this.userinfo);
    this.getObject1("上级");
    this.getObject2("同事");
    this.getObject3("下属");
    this.getObject4("本人");
    this.getTitle();
  },
  methods: {
    //跳转考评
    toUrl(path) {
      const obj = this.optionObject.find((item) => {
        return item.evaluatePersonnelCode == this.valueObject;
      });
      const code = obj.personnelList.map((item) => item.managerCode);
      const params = {
        managerCode: code.join(","), // 上级工号
        evaluatePersonnelCode: obj.evaluatePersonnelCode, // 考评对象工号
        evaluatePersonnelName: obj.evaluatePersonnelName, // 考评对象名字
        evaluatorCode: obj.evaluatorCode, // 考评人工号
        evaluateDescription: this.message,
        deptName: this.userinfo.department,
        activityId: this.valueTitle,
      };
      sessionStorage.setItem("evaluationObject", JSON.stringify(params));
      const { type } = this.$route.query;

      if (type == 2) {
        this.$router.push("/evaluation/questions");
      } else {
        this.$router.push(path);
      }
    },
    // 跳转考评
    toEvaluation(type) {
      if (!this.valueTitle) return this.$message.warning("请选择考评标题");
      const params = {
        // evaluatePersonnelCode: obj.evaluatePersonnelCode, // 考评对象工号
        // evaluatePersonnelName: obj.evaluatePersonnelName, // 考评对象名字
        // evaluatorCode: obj.evaluatorCode, // 考评人工号
        evaluatorCode: this.userinfo.username,
        relation: type,
        deptName: this.userinfo.department,
        activityId: this.valueTitle,
      };
      sessionStorage.setItem("evaluationObject", JSON.stringify(params));
      this.$router.push({
        path: "/evaluation/questions",
        query: {
          type: type,
          activityId: this.valueTitle,
        },
      });
    },
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 获取考评对象
    getObject1(type) {
      const json = {
        evaluatorCode: this.userinfo.username,
        type: type,
      };
      api.evaluatePersonnelQueryDrop(json).then((res) => {
        this.optionObject = res.data;
        res.data.length > 0 &&
          res.data.forEach((item) => {
            this.list1.push(item.evaluatePersonnelName);
          });
      });
    },
    // 获取考评对象
    getObject2(type) {
      const json = {
        evaluatorCode: this.userinfo.username,
        type: type,
      };
      api.evaluatePersonnelQueryDrop(json).then((res) => {
        this.optionObject = res.data;
        res.data.length > 0 &&
          res.data.forEach((item) => {
            this.list2.push(item.evaluatePersonnelName);
          });
      });
    },
    // 获取考评对象
    getObject3(type) {
      const json = {
        evaluatorCode: this.userinfo.username,
        type: type,
      };
      api.evaluatePersonnelQueryDrop(json).then((res) => {
        this.optionObject = res.data;
        
        res.data.length > 0 &&
          res.data.forEach((item) => {
            this.list3.push(item.evaluatePersonnelName);
          });
          console.log(this.list3,'res.datares.data');
      });
    },
    // 获取考评对象
    getObject4(type) {
      const json = {
        evaluatorCode: this.userinfo.username,
        type: type,
      };
      api.evaluatePersonnelQueryDrop(json).then((res) => {
        this.optionObject = res.data;
        res.data.length > 0 &&
          res.data.forEach((item) => {
            this.list4.push(item.evaluatePersonnelName);
          });
      });
    },
    // 获取状态
    getStatus(){
      const params = {
        evaluatorCode: this.userinfo.username,
        activityId: this.valueTitle
      }
      api.evaluateManageQueryEvaluaState(params).then((res) => {
        if(res.code == 200){
          this.statusObj = res.data
          console.log(this.statusObj,'this.statusObj');
          
        }
      })
    },
    // 获取考评标题
    getTitle() {
      const json = {
        page: 1,
        pageSize: 999,
        status: 0,
      };
      api.evaluateActivityList(json).then((res) => {
        this.optionTitle = res.data.list;
        this.valueTitle = res.data?.list[0]?.id;
        this.activityDescription = res.data?.list[0]?.activityDescription;
        this.getStatus()
      });
    },
    // 选择考评标题
    changeTitle(val) {
      if (val) {
        this.activityDescription = this.optionTitle.find((item) => {
          return item.id == val;
        })?.activityDescription;
      }
      this.getStatus()
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  // overflow: hidden;
  overflow: auto;
  padding-top: 30px;
  background: url("~@/assets/evaluation/bg2.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;

  .goback {
    margin: 0 0 60px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;
    }

    i {
      font-weight: bold;
      font-size: 48px;
      margin-right: 30px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .content {
    background: #fff;
    border-radius: 50px 50px 0 0;
    flex: 1;
    padding: 60px 40px 40px;
    position: relative;
    // overflow: auto;
    .evaluationTime {
      color: #ccc;
      font-size: 28px;
      margin-top: 30px;
    }
    .evaluationMes {
      color: #ccc;
      font-size: 28px;
      margin-top: 30px;
      // 自动换行
      word-break: break-all;
    }
    .fild_label {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      position: relative;
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      div {
        color: #0a1629;
        font-weight: bold;
        font-size: 32px;
      }
      .complete {
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 26px;
        border: 1px solid #ea6f42;
        padding: 10px 20px;
        color: #ea6f42;
        border-radius: 10px;
      }
    }
    .fild_value {
      width: 100%;
      ::v-deep {
        .el-input {
          width: 100%;
        }
        .el-select {
          width: 100%;
        }
        .el-input__inner {
          width: 100%;
          height: 80px;
          border-radius: 16px;
          background: #fafafa;
          border: none;
        }
        .van-cell {
          border-radius: 16px;
          background: #fafafa;
        }
      }
    }
    .fild_label2 {
      margin-top: 40px;
    }
    .fild_label3 {
      display: flex;
      justify-content: space-between;
      margin-top: 40px;
      margin-bottom: 20px;
      .label_left {
        display: flex;
        align-items: flex-start;
        div {
          color: #0a1629;
          font-weight: bold;
          font-size: 32px;
        }
      }
      span {
        color: #ff4d4d;
        margin-right: 5px;
        font-size: 32px;
      }
      img {
        width: 50px;
        height: 50px;
      }
    }
    .fild_tag {
      font-size: 28px;
      color: #999999;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tags {
        width: 150px;
        text-align: center;
        margin-bottom: 15px;
        margin-top: 20px;
        div {
          text-align: center;
        }
        img {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          margin-bottom: 20px;
          text-align: center;
        }
      }
    }
    .box_list {
      border: 1px solid #ccc;
      font-size: 28px;
      margin-top: 30px;
      border-radius: 20px;
      position: relative;
      .title {
        padding: 30px;
      }
      .username {
        margin-bottom: 30px;
        padding: 0 30px;
        // 文字溢出缓行
        word-wrap: break-word; /* 旧版浏览器 */
        overflow-wrap: break-word; /* 新版浏览器 */
      }
      .line_two {
        width: 100%;
        height: 2px;
        background: #ccc;
      }
      .fot {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 70px;
        padding-right: 30px;
      }
      .tag{
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 10px 20px;
        border-radius: 10px;
      }
      .green{
        color: #1fbe8a;
        border: 1px solid #1fbe8a;
      }
      .red {
        color: #ff4d4d;
        border: 1px solid #ff4d4d;
      }
    }
    .btn {
      .el-button {
        width: 90%;
        height: 90px;
        background: #1fbe8a;
        border-radius: 10px;
        font-size: 28px;
        color: #fff;
        // position: absolute;
        // bottom: 50px;
        // left: 5%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .is-disabled {
        background: #97e1c9;
        border: 1px solid #97e1c9;
      }
    }
  }
  ::v-deep{
    .el-input__inner{
      color: #000 !important;
    }
  }
}
</style>
